import React, { Component } from 'react'
import Activity from "framework/containers/Activity"
import FormAction from 'app/modules/Accounting/reports/PricelistReport/PricelistReportAction'

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class PricelistReportActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/modules/Accounting/reports/PricelistReport/PricelistReport")
	}

	render() {
		return (
			<Activity 
				name="Pricelist"
				RenderedComponent={this.RenderedComponent}
				context="Pricelist"
				action="Pricelist"
				formActions={FormAction}    
            />
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(PricelistReportActivity)